import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/home-icon/logo.png'
import _imports_1 from '@/assets/home-icon/avatar.png'
import _imports_2 from '@/assets/home-icon/dropicon.png'
import _imports_3 from '@/assets/home-icon/off.png'


const _withScopeId = n => (_pushScopeId("data-v-29c8d590"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "top-bar-content" }
const _hoisted_6 = ["onClick", "onMouseenter", "onMouseleave"]
const _hoisted_7 = { class: "icon-box" }
const _hoisted_8 = {
  key: 0,
  class: "icon-img"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  src: _imports_1
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drop-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_12 = { class: "drop-main" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))

import {ref, reactive, onMounted, computed, nextTick, watch} from 'vue'
import { useStore } from 'vuex';
import day from 'dayjs'
import { useRoute, useRouter } from 'vue-router';
import { NEED_LOGIN_ROUTERS } from '@/const/utils';
import {
  showPcpaperFrameworkLoginEntrance,
  clickPcpaperFrameworkLoginEntrance,
  showPcpaperFrameworkLoginfloat,
  clickPcpaperFrameworkRenewBtn,
  clickPcpaperFrameworkVipBtn,
  showPcpaperFrameworkBlank
} from '@/trace/xesTrackFramework'

export default /*#__PURE__*/_defineComponent({
  __name: 'headerComponent',
  setup(__props) {

const paperVipInfo = computed(() => store.getters['user/paperVipInfo'])
const store = useStore()
const vip = computed(() => paperVipInfo.value?.use_status === 1)
const topbarList = reactive([
  {
    icon:'header-bar-icon1',
    text: "登录/注册",
    toPath: "popupLogin"
  },
  {
    icon: "header-bar-icon2",
    text: "我的试卷",
    toPath: "/myPaper"
  },
  {
    icon: "header-bar-icon3",
    text: "浏览记录",
    toPath: "/browserHistory"
  },
  {
    icon: "header-bar-icon4",
    text: "非会员",
    toPath: "pupupVip"
  }
])
const currentIndex = ref(null)
const userInfo = computed(() => {
  if(store.state.user.userInfo) {
    currentIndex.value = 100
  }
  return store.state.user.userInfo
})
const router = useRouter()
const route = useRoute()
watch(paperVipInfo, (val) => {
  showPcpaperFrameworkBlank({
    is_login: userInfo.value? '是': '否',
    is_vip: vip.value? '是': '否'
  })
})
onMounted(() => {
  starPageInit()
  if(!userInfo.value) {
    showPcpaperFrameworkLoginEntrance()
    showPcpaperFrameworkBlank({
      is_login: '否',
      is_vip: '否'
    })
  }
})
const starPageInit = () => {
  let path = localStorage.getItem('enterPath')
  if(!userInfo.value) return
  if(path) {
    if(path.includes('/')) {
      router.push({
        path
      })
    }else { // 弹会员窗口
      store.dispatch('openVipDialog', {
        position: '会员入口',
        entrance: '试卷宝框架',
      });
    }
    localStorage.setItem('enterPath', '')
  }
}
// 到期时间
const formatTime = () => {
  return day.unix(paperVipInfo.value?.service_expired_time).format('YYYY-MM-DD')
}
// 每一项点击
const handleClick = (tabIndex:number, path: string) => {
  if(!userInfo.value) {
    clickPcpaperFrameworkLoginEntrance()
  }
  if(tabIndex === 3) {
    clickPcpaperFrameworkVipBtn({
      is_login: userInfo.value? '是': '否',
      is_vip: vip.value? '是': '否'
    })
  }
  if(!tabIndex) { // 去登陆
    if(userInfo.value) return
    store.dispatch('openLogin')
    currentIndex.value = tabIndex
    showPcpaperFrameworkLoginfloat()
  }else {
    if(!userInfo.value) { // 未登录
      store.dispatch('openLogin')
      localStorage.setItem('enterPath',  path)
      showPcpaperFrameworkLoginfloat()
    }else {
      if(tabIndex === 3) { // 加入会员弹窗
        store.dispatch('openVipDialog', {
          position: '会员入口',
          entrance: '试卷宝框架',
        }); 
        
      }else {
        router.push({
          path
        })
      }
    }
  }

}

const handleMouseenter = (i:number) => {
  currentIndex.value = i
}
const handlemouseliave = (i:number) => {
    currentIndex.value = 100
}

const openMember = async () => { // 去会员购买页
  await store.dispatch('openVipDialog', {
    position: '登录浮窗',
    entrance: '试卷宝框架',
  });
  clickPcpaperFrameworkRenewBtn({
    content: vip.value ? "立即续费" : '去开通'
  })
  // currentIndex.value = 0
}
const loginout = async () => {   // 退出登录
  await store.dispatch('loginOut')
}
const reload = () => {    // 回首页
  // router.push('/')
  console.log(route.path);
  if(route.path == '/paper' || route.path == '/') {
    location.reload()
  }else {
    router.push('/')
  }
  if(!userInfo.value) currentIndex.value = 0
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "logo",
        onClick: reload
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topbarList, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: i
          }, [
            _createElementVNode("div", {
              class: "item-content",
              onClick: ($event: any) => (handleClick(i, item?.toPath)),
              onMouseenter: ($event: any) => (handleMouseenter(i)),
              onMouseleave: ($event: any) => (handlemouseliave(i))
            }, [
              _createElementVNode("div", _hoisted_7, [
                (userInfo.value && i === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (userInfo.value?.avatar_url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: userInfo.value?.avatar_url
                          }, null, 8, _hoisted_9))
                        : (_openBlock(), _createElementBlock("img", _hoisted_10))
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(['icon', item.icon])
                    }, null, 2))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(['text', i == currentIndex.value && 'picked', i===3 && 's-picked'])
              }, [
                (i === 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(userInfo.value?.nickname || item.text), 1)
                    ], 64))
                  : (i === 3)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(vip.value ? '查看权益' : item.text), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ], 64))
              ], 2)
            ], 40, _hoisted_6),
            (userInfo.value && i == 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "drop-content",
                  onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (handleMouseenter(0))),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (handlemouseliave(0)))
                }, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(vip.value ? `${formatTime()}到期` : '暂未开通会员'), 1),
                    _createElementVNode("div", {
                      class: "off",
                      onClick: loginout
                    }, [
                      _hoisted_14,
                      _createTextVNode("退出 ")
                    ])
                  ])
                ], 32))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})